<h3 mat-dialog-title>Instruções para Ligação</h3>
<div mat-dialog-content>
  <div class="mb-3">
    {{data.midia.texto}}
  </div>

  <div class="mt-3" *ngIf="!clicouLigacao; else resultLigacao">
    <a [href]="'tel:55' + data.midia.telefone" (click)="openLigacao()" class="btn btn-block  mb-2 text-uppercase"
      [ngClass]="'btn-action-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()">continuar para
      ligação</a>
    <button (click)="close()" class="btn btn-block  mb-2 text-uppercase"
      [ngClass]="'btn-cancel-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()">voltar</button>
  </div>
  <ng-template #resultLigacao>
    <button (click)="conseguiu()" class="btn btn-block btn-azul mb-2 text-uppercase"
      [ngClass]="'btn-action-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()">consegui</button>
    <button (click)="naoConsegui()" class="btn btn-block mb-2 text-uppercase"
      [ngClass]="'btn-cancel-' + securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()">não consegui</button>
  </ng-template>
